import(/* webpackMode: "eager" */ "/home/ubuntu/download/6932db6a5a24100014374961/the_vibe_inventor/src/app/not-found.tsx");
